import { useSyncExternalStore, useMemo, useEffect } from "react";
import { ServiceMetadataService } from "@domain/services/serviceMetadata.service";
import { ServiceType } from "@domain/enums/machine.enums";

export function useServiceMetadata() {
  const store = ServiceMetadataService.getStore();
  const state = useSyncExternalStore(store.subscribe, store.getState);

  useEffect(() => {
    ServiceMetadataService.loadServices();
  }, []);

  const orderedWithDisabledLast = useMemo(
    () => store.getOrderedServicesWithDisabledLast().map((s) => s.serviceType as ServiceType),
    [store, state.services]
  );

  const orderedTopLevelServiceTypes = useMemo(
    () => store.getOrderedTopLevelServiceTypes(),
    [store, state.services]
  );

  const actions = useMemo(() => ({
    getByType: (type: ServiceType | string) => store.getByType(type),
    getOrdered: () => store.getOrderedServices(),
  }), [store]);

  return {
    services: state.services,
    loaded: state.loaded,
    orderedServiceTypes: orderedWithDisabledLast,
    orderedTopLevelServiceTypes,
    ...actions,
  };
}
